/***
 * 数据分析
 */
import { post, get, postJson, put } from '../axios'
const RESOURCE_BASE_PATH = '/rfm-analyse'

// 生成人群
export const generateCrowd = p => postJson(`${RESOURCE_BASE_PATH}/generateCrowd`, p);

